export enum InteractionEvent {
  DATA_CELL_CLICK_EVENT = 'interaction:data-cell-click',
  MERGED_CELLS_CLICK_EVENT = 'interaction:merged-cells-click',
  CORNER_TEXT_CLICK_EVENT = 'interaction:corner-cell-text-click',
  ROW_COLUMN_CLICK_EVENT = 'interaction:row-column-click',
  ROW_TEXT_CLICK_EVENT = 'interaction:row-text-click',
  HOVER_EVENT = 'interaction:hover',
}
